import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3838206175/src/apps/webapp/src/components/products/PMaxAdBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3838206175/src/apps/webapp/src/components/products/ProductBreadcrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryBoundary"] */ "/codebuild/output/src3838206175/src/apps/webapp/src/components/ui/QueryBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3838206175/src/apps/webapp/src/containers/product-detail/sections/ProductBuySection/ProductBuySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3838206175/src/apps/webapp/src/containers/product-detail/sections/ProductContentSection/ProductContentSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3838206175/src/apps/webapp/src/containers/product-detail/sections/ProductImageGallerySection/ProductImageGallerySection.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3838206175/src/apps/webapp/src/utils/logger/components/KlaviyoLoggingView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useKlaviyoLogger"] */ "/codebuild/output/src3838206175/src/apps/webapp/src/utils/logger/hooks/useKlaviyoLogger.ts");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3838206175/src/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3838206175/src/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3838206175/src/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/codebuild/output/src3838206175/src/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/codebuild/output/src3838206175/src/node_modules/@tanstack/react-query/build/modern/IsRestoringProvider.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3838206175/src/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/codebuild/output/src3838206175/src/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/codebuild/output/src3838206175/src/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/codebuild/output/src3838206175/src/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/codebuild/output/src3838206175/src/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/codebuild/output/src3838206175/src/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/codebuild/output/src3838206175/src/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/codebuild/output/src3838206175/src/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/codebuild/output/src3838206175/src/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/codebuild/output/src3838206175/src/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/codebuild/output/src3838206175/src/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3838206175/src/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3838206175/src/packages/design-system/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useAsyncEffect"] */ "/codebuild/output/src3838206175/src/packages/utils/src/hooks/useAsyncEffect.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useCallbackRef"] */ "/codebuild/output/src3838206175/src/packages/utils/src/hooks/useCallbackRef.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useCombinedRefs"] */ "/codebuild/output/src3838206175/src/packages/utils/src/hooks/useCombinedRef.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useDebouncedNumberCommit"] */ "/codebuild/output/src3838206175/src/packages/utils/src/hooks/useDebouncedNumberCommit.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useDidUpdate"] */ "/codebuild/output/src3838206175/src/packages/utils/src/hooks/useDidUpdate.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useEffectOnce"] */ "/codebuild/output/src3838206175/src/packages/utils/src/hooks/useEffectOnce.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useEventListener"] */ "/codebuild/output/src3838206175/src/packages/utils/src/hooks/useEventListener.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useImpression"] */ "/codebuild/output/src3838206175/src/packages/utils/src/hooks/useImpression.ts");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3838206175/src/packages/utils/src/hooks/useImpressionRef.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useIsClient"] */ "/codebuild/output/src3838206175/src/packages/utils/src/hooks/useIsClient.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useIsTouchDevice"] */ "/codebuild/output/src3838206175/src/packages/utils/src/hooks/useIsTouchDevice.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useMutationLoading"] */ "/codebuild/output/src3838206175/src/packages/utils/src/hooks/useMutationLoading.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useOutsideClickEffect"] */ "/codebuild/output/src3838206175/src/packages/utils/src/hooks/useOutsideClickEffect.ts");
;
import(/* webpackMode: "eager", webpackExports: ["usePageInfo"] */ "/codebuild/output/src3838206175/src/packages/utils/src/hooks/usePageInfo.ts");
;
import(/* webpackMode: "eager", webpackExports: ["usePreservedCallback"] */ "/codebuild/output/src3838206175/src/packages/utils/src/hooks/usePreservedCallback.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useRefEffect"] */ "/codebuild/output/src3838206175/src/packages/utils/src/hooks/useRefEvent.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useVisibilityEvent"] */ "/codebuild/output/src3838206175/src/packages/utils/src/hooks/useVisibilityEvent.ts");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3838206175/src/packages/utils/src/logger/components/LoggingEvent.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3838206175/src/packages/utils/src/logger/components/LoggingImpression.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3838206175/src/packages/utils/src/logger/components/LoggingView.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3838206175/src/packages/utils/src/logger/hooks/useLogger.ts");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3838206175/src/packages/utils/src/logger/hooks/usePageLogger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoggerProvider","useLoggerRootContext"] */ "/codebuild/output/src3838206175/src/packages/utils/src/logger/Logger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientOnly"] */ "/codebuild/output/src3838206175/src/packages/utils/src/react/ClientOnly.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["createSafeContext"] */ "/codebuild/output/src3838206175/src/packages/utils/src/react/createSafeContext.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/codebuild/output/src3838206175/src/packages/utils/src/react/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImpressionArea"] */ "/codebuild/output/src3838206175/src/packages/utils/src/react/ImpressionArea.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["makeExternalStore"] */ "/codebuild/output/src3838206175/src/packages/utils/src/storage/makeExternalStore.ts");
